import { supabase } from "./supabase";

/** Worker は同一オリジンの /api/* にいる(→ ADR-0013)。CORS の設定は不要 */
async function callApi<T>(path: string, body: unknown): Promise<T> {
  const { data, error } = await supabase.auth.getSession();
  if (error) throw error;
  const token = data.session?.access_token;
  if (token === undefined) throw new Error("サインインが必要です");

  const response = await fetch(path, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "content-type": "application/json",
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const detail = (await response.json().catch(() => null)) as { error?: string } | null;
    throw new Error(detail?.error ?? `リクエストに失敗しました (${String(response.status)})`);
  }
  return response.json() as Promise<T>;
}

export interface UploadTarget {
  mediaId: string;
  storageKey: string;
  thumbnailKey: string;
  originalUrl: string;
  thumbnailUrl: string;
}

export function requestUploadUrls(mimeType: string, byteSize: number): Promise<UploadTarget> {
  return callApi<UploadTarget>("/api/uploads/presign", { mimeType, byteSize });
}

/** キーごとの署名付きURL。TTL は1時間で、期限切れは再取得で復旧する */
export async function signMediaUrls(keys: string[]): Promise<Record<string, string>> {
  if (keys.length === 0) return {};
  const { urls } = await callApi<{ urls: Record<string, string> }>("/api/media/sign", { keys });
  return urls;
}

/**
 * R2 のオブジェクトを物理削除する。取り消せない。
 * 1回に渡せる件数には Worker 側の上限がある(→ PURGE_CHUNK)。
 */
export async function purgeMediaObjects(keys: string[]): Promise<void> {
  if (keys.length === 0) return;
  await callApi<{ deleted: number }>("/api/media/purge", { keys });
}
